<template>
  <div>
    <ul class="tab">
      <li class="tab-item" :class="{'tab-item-current':current==0}" @click="changeTab(0)">本周课表</li>
      <li class="tab-item" :class="{'tab-item-current':current==1}" @click="changeTab(1)">下周课表</li>
    </ul>
    <div class="tab-content">
      <table class="table">
        <thead>
          <tr>
            <th></th>
            <th v-for="(date,index) in dateList.date" :key="index">
              {{weeks[index]}}
              <br />
              {{date}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="time in dateList.time" :key="time">
            <td>{{time}}</td>
            <td
              v-for="(date,index) in dateList.date"
              @click="timeClick(index,time)"
              :class="{'schedule-new':timeSchedules[index][time]==1,'schedule-plan':timeSchedules[index][time]==2}"
              :key="index"
            >
              <div v-if="current==1&&timeSchedules[index][time]">
                <div
                  class="schedule-case"
                  v-if="!dateCourse[index][time]||dateCourse[index][time].user_id==0"
                >{{weeks[index]+" "+time}}</div>
                <div
                  class="schedule-case schedule-case-past"
                  v-else
                  @click.stop="cancelPast(dateCourse[index][time])"
                >{{dateCourse[index][time].nickname}}</div>
              </div>
              <div v-if="dateCourse[index][time]&&current==0">
                <div v-if="dateCourse[index][time].user_id==0">
                  <div
                    class="schedule-case schedule-case-none"
                    v-if="index+1<currentWeekDay||(index+1==currentWeekDay&&time<currentTime)"
                  >无预约</div>
                  <div v-else class="schedule-case schedule-case-waiting">待预约</div>
                </div>
                <div v-else>
                  <div
                    class="schedule-case schedule-case-past"
                    v-if="index+1<currentWeekDay||(index+1==currentWeekDay&&time<currentTime)"
                  >{{dateCourse[index][time].nickname}}</div>
                  <div
                    v-else
                    class="schedule-case schedule-case-future"
                  >{{dateCourse[index][time].nickname}}</div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="text-align:center;padding-top:15px;">
        <Button type="warning" size="large" v-if="!editable&&current==1" @click="editable=true">编辑排课</Button>
        <Button type="warning" size="large" v-if="editable&&current==1" @click="submitSchedule">确定排课</Button>
      </div>
    </div>
    <div>
      <div style="font-size:16px;">排课须知：</div>
      <div>1、老师需在每{{setting.week_start_day}}至{{setting.week_end_day}}进行下周预约课程排课， 每{{setting.week_end_day}}{{setting.time}}前需提交下周排课；</div>
      <div>2、单个课次预约时间为{{setting.chapter_time}}分钟，支持增加单个课次的上课时间（例如：单位时间为30分钟，选中10:00即最小上课时间为10:00-10:30）。</div>
      <div>3、单击时间段，进行排课，再次点击可删除选择的时间段。</div>
    </div>
    <Modal v-model="showScheduleResultModal" title="排课确认" :closable="false" :mask-closable="false">
      <ul class="schedule-result">
        <li v-for="(item,index) in scheduleResult" :key="index">{{item}}</li>
      </ul>
      <div class="schedule-tips" v-if="tips.length">
        <div>重要提示：</div>
        <ul>
          <li v-for="(item,index) in tips" :key="index">{{item}}</li>
          <li>以上预约课时可能和班课上课时间有冲突！</li>
        </ul>
      </div>
      <template slot="footer">
        <div style="text-align:center;">
          <Button @click="showScheduleResultModal=false">再想想</Button>
          <Button type="warning" @click="confirmSubmitSchedule" :loading="loading">确定</Button>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "TeachOtoScheduleDetail",
  props: {
    teacherID: {
      default: ""
    }
  },
  async created() {
    if (this.$route.query.name) {
      this.$route.meta.title = this.$route.query.name;
    }
    this.setting = await this.$http.get("/api/invite/setting/1");
    await this.getData();
  },
  data() {
    return {
      current: 0,
      dateList: [],
      weeks: {
        0: "周一",
        1: "周二",
        2: "周三",
        3: "周四",
        4: "周五",
        5: "周六",
        6: "周日"
      },
      dateCourse: {},
      currentWeekDay: "",
      currentTime: "",
      editable: false,
      timeSchedules: {
        0: {},
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {}
      },
      scheduleResult: [],
      showScheduleResultModal: false,
      chapter_time: 0,
      course_time: [],
      tips: [],
      teacher_id: this.teacherID || this.$route.query.id,
      loading: false,
      setting: {}
    };
  },
  methods: {
    async getData() {
      let current = this.current;
      let data = await this.$http.get(
        "/api/oto/course/" + this.teacher_id + "/" + current
      );
      this.dateList = data.dateList;

      let dateCourse = {};
      let courses = data.otoCourseList;
      let times = data.dateList.time;
      let date = new Date();
      this.currentWeekDay = date.getDay();
      this.currentWeekDay = this.currentWeekDay == 0 ? 7 : this.currentWeekDay;
      this.currentTime = date.format("hh:mm");
      let weekDay = date.getDay();
      if (weekDay == 0) {
        date.setDate(date.getDate() - 6);
      } else {
        date.setDate(date.getDate() - (weekDay - 1));
      }
      date.setSeconds(0);
      date.setMilliseconds(0);
      if (current == 1) {
        date.setDate(date.getDate() + 7);
      }
      let beginYear = date.getFullYear();
      let beginMonth = date.getMonth();
      let beginDate = date.getDate();
      for (let i = 0; i <= 6; i++) {
        dateCourse[i] = {};
        date = new Date(date.getTime());
        date.setFullYear(beginYear);
        date.setMonth(beginMonth);
        date.setDate(beginDate + i);
        for (let j = 0; j < times.length; j++) {
          let time = times[j];
          let array = time.split(":");
          let hour = parseInt(array[0]);
          let minute = parseInt(array[1]);
          date.setHours(hour);
          date.setMinutes(minute);
          let seconds = parseInt(date.getTime() / 1000);
          let timeCourses = courses.filter(
            c => c.start_play <= seconds && c.end_play >= seconds
          );
          dateCourse[i][time] = timeCourses[0];
          if (timeCourses.length > 0) {
            this.$set(this.timeSchedules[i], time, current == 1 ? 2 : 0);
          }
        }
      }
      this.dateCourse = dateCourse;

      if (current == 1) {
        this.chapter_time = data.otoSetting.chapter_time;
      }
    },
    async changeTab(current) {
      this.current = current;
      await this.getData();
    },
    timeClick(index, time) {
      if (!this.editable) {
        return;
      }
      let flag = this.timeSchedules[index][time];
      if (flag) {
        this.$set(this.timeSchedules[index], time, 0);
      } else {
        this.$set(this.timeSchedules[index], time, 1);
      }
    },
    async submitSchedule() {
      let course_time = [];
      let date = new Date();
      let weekDay = date.getDay();
      if (weekDay == 0) {
        date.setDate(date.getDate() + 1);
      } else {
        date.setDate(date.getDate() - (weekDay - 1) + 7);
      }
      let beginYear = date.getFullYear();
      let beginMonth = date.getMonth();
      let beginDate = date.getDate();
      let chapter_time = this.chapter_time;
      for (let i = 0; i <= 6; i++) {
        date = new Date(date.getTime());
        date.setFullYear(beginYear);
        date.setMonth(beginMonth);
        date.setDate(beginDate + i);

        let dateStr = date.format("yyyy-MM-dd");
        let timeSchedule = this.timeSchedules[i];
        for (let key in timeSchedule) {
          if (timeSchedule[key]) {
            let start_play = dateStr + " " + key;
            let end_play = new Date(start_play);
            end_play.setMinutes(end_play.getMinutes() + chapter_time);
            end_play = end_play.format("yyyy-MM-dd hh:mm");
            course_time.push({
              start_play: start_play,
              end_play: end_play
            });
          }
        }
      }
      this.course_time = course_time;
      let data = await this.$http.post("/api/oto/dispatch/update", {
        teacher_id: this.teacher_id,
        course_time: JSON.stringify(course_time),
        flag: 1
      });
      this.scheduleResult = data.dispatch;
      this.tips = data.tips;
      this.showScheduleResultModal = true;
      this.loading = false;
    },
    async confirmSubmitSchedule() {
      this.loading = true;
      await this.$http.post("/api/oto/dispatch/update", {
        teacher_id: this.teacher_id,
        course_time: JSON.stringify(this.course_time),
        flag: 0
      });
      this.loading = false;
      this.showScheduleResultModal = false;
      this.$Message.saveSuccess();
      await this.changeTab(1);
      this.editable = false;
    },
    cancelPast(course) {
      if (!this.editable) {
        return;
      }
      this.$Modal.info({
        title: "提示",
        content:
          "该课程已被学员预约，不可取消，请联系学员" +
          course.nickname +
          "（" +
          course.mobile +
          "）主动取消。"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.tab {
  overflow: hidden;
}

.tab-item {
  float: left;
  width: 178px;
  height: 56px;
  text-align: center;
  line-height: 56px;
  border: 1px solid #ddd;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.3s;
}

.tab-item-current {
  background-color: #ff9900;
  color: white;
  border-color: #ff9900;
}

.table {
  width: 100%;
  border: 1px solid #d7d7d7;
  border-collapse: collapse;
}

.table th,
.table td {
  border: 1px solid #d7d7d7;
  text-align: center;
}

.table td {
  padding: 10px 0;
  position: relative;
}

.table thead th {
  background-color: #e4e4e4;
  padding: 12px 0;
}

.tab-content {
  padding-top: 30px;
}

.schedule-case {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.schedule-case-waiting {
  color: red;
}

.schedule-case-past {
  background-color: #cccccc;
  color: white;
}

.schedule-case-future {
  background-color: #ffcc00;
  color: white;
}

.table .schedule-new .schedule-case {
  border: 1px solid #ff9900;
  color: #ff9900;
}

.table .schedule-plan .schedule-case {
  background-color: #ff9900;
  color: white;
}

.table .schedule-plan .schedule-case-past {
  background-color: #cccccc;
}

.schedule-result {
  width: 220px;
  margin: 0 auto;
}

.schedule-tips {
  color: #ff9900;
  width: 360px;
  margin: 0 auto;
}

.schedule-tips ul {
  margin-left: 60px;
}
</style>
